import { handle as handleStats } from './handlers/stats.js';
import { handle as handleUi }    from './handlers/ui.js';

const ROUTES = {
  'state:started':   [handleStats],
  'state:progress':   [handleStats],
  'state:complete':   [handleStats],
  'action:next':  [handleUi],
  'state:change': [handleStats, handleUi],
};

export function initDispatch() {
  if (typeof window.qcmOnDispatch !== 'function') {
    console.warn('[dispatch] qcmOnDispatch non disponible');
    return;
  }
  window.qcmOnDispatch((type, data) => {
    ROUTES[type]?.forEach(fn => fn(type, data));
  });
}
